import Image from 'next/image'

import { Classified } from '../../rest/types/Classified'
import { AdsMediaSliderModalProps } from '../../components/AdsMediaSliderModal'
import { UrlImageTransformer } from '../Transformers/ImageTransformer'
import Video from '../../components/Video'
import Icon, { Icons } from '../../components/Icon'

export function useAdsMediaSliderModalProps({
  classified,
  setIsMediaSliderModalOpen,
  isMediaSliderModalOpen,
  sliderRef,
}: {
  classified?: Classified
  setIsMediaSliderModalOpen: (bool: boolean) => void
  isMediaSliderModalOpen: boolean
  sliderRef: any
}): AdsMediaSliderModalProps | undefined {
  return classified
    ? {
        items: classified?.medias?.length
          ? classified?.medias.map((item) => {
              return {
                title: item.title ?? '',
                description: item.description ?? '',
                ...(item?.photo && {
                  media: (
                    <Image
                      src={UrlImageTransformer((item?.photo as any)?.url)}
                      width={525}
                      height={311}
                      alt={'test'}
                    />
                  ),
                }),
                ...(item?.videoUrl && {
                  media: (
                    <Video
                      controls={true}
                      url={UrlImageTransformer(item?.videoUrl)}
                    />
                  ),
                }),
                ...(item?.document && {
                  media: (
                    <a
                      style={{
                        display: 'inline-block',
                        height: '50px',
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        color: 'unset',
                      }}
                      href={UrlImageTransformer((item?.document as any)?.url)}
                      target={'_blank'}
                      rel="noopener noreferrer"
                    >
                      <Icon icon={Icons.doc} width={50} height={50} />
                    </a>
                  ),
                }),
              }
            })
          : [],
        isOpen: isMediaSliderModalOpen,
        onClose: () => setIsMediaSliderModalOpen(false),
        sliderRef: sliderRef,
      }
    : undefined
}
